import type { CampaignStats } from "schemas";
import { apiRequest } from "../apiRequest";

export async function fetchCampaignStats(id: string): Promise<CampaignStats> {
  const { stats } = await apiRequest<{ stats: CampaignStats }>({ url: `campaigns/${id}/stats` });

  return stats;
}
